import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
  Chip,
  Avatar,
  IconButton,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Group,
  ArrowForwardIos,
  Block,
  CheckCircle,
  Close,
  Refresh,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";

import { Skeleton } from "@material-ui/lab";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
} from "../../../../../../utils/web_config";
import { useTransactionTypes } from "../../../../hooks/use_hooks";

import Format from "date-fns/format";
import { DatePicker } from "@material-ui/pickers";




const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function FinancialSettlement(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const [initiating,setInitiating]=useState({open:false,loading:false})

  const [processes, setProcesses] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading settlement processes....",
    loading: false,
    toggling: false,
    data: [],
  });

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getProcesses(accountData.token);
  }, []);

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const onFromChange = (date) => {
    setFrom({ value: date, error: "" });
  };
  //////////
  const processColums = [
    {
      name: "process_reference",
      label: "Process reference",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "settlement_date",
      label: "Settlement date",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "start_time",
      label: "Start time",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "end_time",
      label: "End time",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_count",
      label: "Total Counts",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_completed",
      label: "Count Completed",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_reversed",
      label: "Count Reversed",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_amount_completed",
      label: "Total Amount Completed",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_amount_reversed",
      label: "Total Amount Reversed",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "trx_amount",
      label: "Settled Amount",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "settlement_status",
      label: "Settlement Status",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "transfer_status",
      label: "transfer Status",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {processes.data[dataI].status.toLowerCase() == "collected" ? (
                    <CheckCircle fontSize="small" />
                  ) :processes.data[dataI].status.toLowerCase() == "initializing" || processes.data[dataI].status.toLowerCase() == "processing"?<Refresh fontSize='small'/>: (
                      <Block fontSize="small" />
                    )}
                </Avatar>
              }
              variant="outlined"
              color={
                processes.data[dataI].status.toLowerCase() == "collected" || processes.data[dataI].status.toLowerCase() == "initializing" || processes.data[dataI].status.toLowerCase() == "processing"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(processes.data[dataI].status)}
            />
          );
        },
      },
    },
  ];

  const processOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search process...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      var pro = processes.data[cellMeta.dataIndex];

      history.push("/centrika/reports/finance/financialTransaction", pro);
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: processes.status,
      },
    },
  };

  ///////////////////////////////////

  const getProcesses = (token) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setProcesses({ ...processes, loading: true });

    console.log("getting processes .....");

    usersInstance
      .get(new FinanceService().GET_FINANCIAL_SETTLEMENT_PROCESSES + "?per_page=1000")
      .then(function (response) {
        setProcesses({ ...processes, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setProcesses({
            ...processes,
            status: "There are no financial settlement processes available",
          });
        } else {
          setProcesses({ ...processes, data: d.data, allData: d.data });
        }
      })
      .catch(function (error) {
        setProcesses({ ...processes, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setProcesses({ ...processes, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


    //////////////////////////////////

    const initiateProcess= () => {
      const createInstance = axios.create(
        new AdminService().getHeaders(accountData.token)
      );
  
      setInitiating({...initiating,loading:true});
      const data = {
        "settlement_date":Format(from.value, ["yyyy-MM-dd"])
      }

      createInstance
        .post(new FinanceService().INITIATE_SETTLEMENT_PROCESS, data)
        .then(function (response) {
          setInitiating({open:false,loading:false});
          var d = response.data;
  
          getProcesses(accountData.token)
          notify("success", "Settlement process initiated successfully");

        })
        .catch(function (error) {
          setInitiating({open:false,loading:false});
          var e = error.message;
  
          if (error.response) {
            e = error.response.data.message;
          }
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    };
  
    //////////////////////////////////

  return (
    <div className={classes.root}>

<Dialog
        open={initiating.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={()=>setInitiating({...initiating,open:false})}
      >
        <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to initiate settlement process, select date to initiate.
          </DialogContentText>
          <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                placeholder="Select date"
                autoOk
                disableFuture
                label={<Translate id="reports.forms.labels.from" />}
                value={from.value}
                inputVariant="outlined"
                onChange={onFromChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setInitiating({...initiating,open:false})
            }}
            color="primary"
            variant='outlined'
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              initiateProcess()
            }}
            variant='contained'
            color="primary"
            disableElevation
          disabled={initiating.loading}
            autoFocus
          >
            {initiating.loading?<CircularProgress size={23}/>:'Initiate'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialogs ends here */}
      <Box display="flex" alignItems="center">

        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6">Financial Settlements</Typography>
        </Box>
        
      </Box>
      <Box mt={3} />

      {processes.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of financial settlement processes"}
        data={processes.data}
        columns={processColums}
        options={processOptions}
      />
    </div>
  );
}




export default withLocalize(FinancialSettlement);
